import { IItem, ITotals } from '@checkout/items';
import * as cx from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { SummaryRow } from '..';
import { ProductsList } from '../../container';
import messages from './../../../i18n/base-en';
import * as Styles from './Summary.scss';

interface IOwnProps {
  totals: ITotals;
  title?: string;
  items?: IItem[];
}

type Props = IOwnProps & InjectedIntlProps;

const Summary: React.SFC<Props> = ({ intl, totals, title, items }) => {
  const { formatMessage } = intl;

  const titleClassNames = cx({
    [Styles.title]: true,
    [Styles.receiptTitle]: !!items
  });

  if (!totals) { return null; }

  return (
    <div className={Styles.content}>
      {title && <div className={titleClassNames}>{title}</div>}
      {items && <div className={Styles.items}><ProductsList items={items} readOnly={true} /></div>}
      <SummaryRow label={formatMessage(messages.subtotal_label)} value={totals.itemsTotalPrice} />
      <SummaryRow
        label={formatMessage(messages.shipping_sumary_label)}
        value={totals.shippingPrice}
      />
      {totals.handlingCostPriceAsNumber > 0 && (
        <SummaryRow
          label={formatMessage(messages.payment_handling_label)}
          value={totals.handlingCostPrice}
        />
      )}
      {totals.taxDeducted && (
        <SummaryRow
          label={formatMessage(messages.tax_deducted_label)}
          value={totals.taxDeducted}
        />
      )}
      <SummaryRow total={true} label={formatMessage(messages.total_label)} value={totals.grandTotalPrice} />
      {totals.taxPercent > 0 && (
        <SummaryRow
          variant={'smaller'}
          label={formatMessage(messages.including_tax_label, { taxPercent: totals.taxPercent })}
          value={totals.grandTotalPriceTax}
        />
      )}
      {totals.totalDiscountPrice && (
        <SummaryRow variant={'small'} label={formatMessage(messages.discount_label)} value={totals.totalDiscountPrice} />
      )}
    </div>
  );
};

export default injectIntl<IOwnProps>(Summary);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/Summary/Summary.tsx